import React from 'react';
import './KeyValuePairs.scss';

type KeyValuePair = {
  key: string;
  value: string | null | number;
};

type KeyValuePairsColor = 'black' | 'grey';

type KeyValuePairsProps = {
  pairs: KeyValuePair[];
  boldValues?: boolean;
  color?: KeyValuePairsColor;
};

const KeyValuePairs: React.FC<KeyValuePairsProps> = ({
  pairs,
  boldValues,
  color = 'black',
}) => {
  const colorClass =
    color === 'grey' ? 'text-grey-value-pairs' : 'text-dark-value-pairs';

  return (
    <div className="space-y-2">
      {pairs.map((pair) => (
        <div key={pair.key} className="flex justify-start items-center">
          <span className={`${colorClass} font-semibold mr-2`}>
            {pair.key}:
          </span>
          <span className={colorClass}>
            {boldValues ? <strong>{pair.value}</strong> : pair.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default KeyValuePairs;
